import { instance } from '../lib/api'

export const DROP_OPP_SUCCESS = 'DROP_OPP_SUCCESS'
export const DROP_OPP_FAIL = 'DROP_OPP_FAIL'

export const dropOpportunitySubmit = id => {
  return dispatch => {
    const url = `/sapna/rcm/drop-opportunity?opportunityId=${id}`
    const data = {
      opportunityId: id
    }
    return instance({
      url,
      method: 'post',
      data
    })
      .then(response => {
        dispatch({
          type: DROP_OPP_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(error => {
        const {
          response: {
            data: { error: { msg = 'Something went wrong' } = {} } = {}
          } = {}
        } = error || {}
        dispatch({
          type: DROP_OPP_FAIL,
          message: msg
        })
      })
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/dropOpportunity.js
 **/